import React from 'react';
import styled from 'styled-components';
import { Splide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { useSelector } from 'react-redux';

// styles
const Wrapper = styled.div`
    width: 100%;
    height: auto;
    ${p => p.arrow && `
      padding: 0 40px;
    `}
    ${p => p => p.arrow && !p.arrowOnDesktop && `
      @media (max-width: 700px) {
        padding: 0 30px;
      }
      @media (min-width: 700px) {
        padding: 0;
      }
    `}
    .slider {
      direction: ${p => p.webConfig.dir};
      ${p => p.arrow && p.arrowButtonShadow && `
        box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.05);
      `}
    }
    .slide {
      padding: 0;
      ${p => p.webConfig.dir === 'ltr' && p.padding-0 && `
        transform: translateX(-20px);
      `}
      ${p => p.padding && `
        padding: 3px;
     `}
    }
    ${p => !p.arrow && `
      .splide__arrows {
        display: none;
      }
    `}
    ${p => p.arrow && !p.arrowOnDesktop && `
      .splide__arrows {
        @media (min-width: 700px) {
          display: none;
        }
      }
    `}
    .next-button, .prev-button {
		  z-index: 3;
		  width: 24px;
		  height: 24px;
		  background: transparent;
      cursor: pointer;
      top: 30%;
      opacity: 1;
    }
    .prev-button {
      ${p => p.webConfig.dir === 'ltr' && `
        transform: translateX(-45px) !important;
      `}
      transform: translateX(45px);
    }
    .next-button {
      ${p => p.webConfig.dir === 'ltr' && `
        transform: translateX(45px) !important;
      `}
      transform: translateX(-45px);
    }
    .splide__arrow svg {
      fill: #fff;
    }
`;

const Carousel = ({ id, renderItem, items, perPage, autoplay, gap, arrow = true, arrowOnDesktop = true, padding, arrowButtonShadow = true }) => {
  const {webConfig} = useSelector(state => state.core);
  
  const defaultOption = {
    type: autoplay ? 'loop' : 'slide',
    pagination: false,
    direction: webConfig.dir,
    omitEnd: true,
    speed: 300,
    easing: 'linear',
    perMove: 1,
    autoplay: autoplay,
    interval: autoplay ? 3000 : 0,
    pauseOnHover : false,
    resetProgress: false,
    isNavigation: false,
    gap: webConfig.dir === 'ltr' ? 0 : gap ?? 20,
  }

  let rest;
  perPage
  ?
  rest = {
    perPage: perPage,
  }
  :
  rest = {
    autoWidth: true,
  }

    return (
      <Wrapper 
        arrow={arrow}
        arrowOnDesktop={arrowOnDesktop}
        arrowButtonShadow={arrowButtonShadow}
        webConfig={webConfig}
        padding={padding}
        padding-0={id === 'blog-posts' || id === 'collaborate'}
      >
         <Splide
            id={id}
            className="slider"
            hasTrack={false}
            options={{
              ...defaultOption,
              ...rest
            }}
          >
         
            <div className="splide__arrows">
              <button className="prev-button splide__arrow splide__arrow--prev">
                {webConfig.dir === 'ltr' 
                ?
                <img
                  src="/nextasset/images/get-appointment/arrow-left.svg"
                  alt="arrow-left-icon"
                  height={24}
                  width={24}
                />
                :
                <img
                  src="/nextasset/images/get-appointment/arrow-right.svg"
                  alt="arrow-right-icon"
                  height={24}
                  width={24}
                />
                }
              </button>
              <button 
                className='next-button splide__arrow splide__arrow--next'
              >
                {webConfig.dir === 'ltr' 
                ?
                <img
                  src="/nextasset/images/get-appointment/arrow-right.svg"
                  alt="arrow-right-icon"
                  height={24}
                  width={24}
                />
                :
                <img
                  src="/nextasset/images/get-appointment/arrow-left.svg"
                  alt="arrow-left-icon"
                  height={24}
                  width={24}
                />
                }
              </button>
            </div>     

            <SplideTrack>
				    {items?.map((item, index) => 
                <SplideSlide 
                  key={index}
                  className='slide'
                >
                    {renderItem({ item: item })}
                </SplideSlide>
              )}
            </SplideTrack>

        </Splide>
      </Wrapper>
    )
}

export default Carousel;